import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import api from "../api/api";
import { Creators as Actions, Types } from "ducks/Notas";
import { Creators as ActionsGeral } from "ducks/Geral";
import notify from 'utils/modern_notify';

const buscarNotaReq = async filtros =>
    api
        .get(`/api/dashboard/buscar/unicanota`, filtros)
        .then(dados => dados)
        .catch(error => error);

let notaMens = "";
function* buscarNota({ payload }) {
    const { id } = payload;
    const dados = {
        id
    };
    notaMens = "";
    let dadosNota = [];
    try {
        // yield put(Actions.buscarNotasDashSucesso(notas));
        const response = yield call(buscarNotaReq, dados);
        if (response.ok) {
            if (response.data.resultado) {
                dadosNota = response.data.valor.shift();
                yield put(Actions.buscarNotaSucesso(dadosNota));
            } else {
                if (
                    Object.prototype.hasOwnProperty.call(response.data, "error")
                ) {
                    switch (response.data.error) {
                        default:
                            notaMens = `Ocorreu um erro ao buscar nota: ${response.data.error}`;
                            break;
                    }
                } else {
                    notaMens =
                        "Ocorreu um erro ao buscar nota. Tente novamente";
                }
                // yield put(
                //     ActionsGeral.setMensagem({
                //         mensagem: notaMens,
                //         mostrar: true
                //     })
                // );
                notify(notaMens)
            }
        } else {
            notify("Erro ao buscar nota")
        }
    } catch (error) {
        notify(`Erro inesperado buscar nota: ${error}`)
    }
}

export function* sagaBuscarNota() {
    yield takeLatest(Types.BUSCAR_NOTA, buscarNota);
}
export default function* rootSaga() {
    yield all([fork(sagaBuscarNota)]);
}
